export const SET_COUPON_VERIFY_ITEM = 'SET_COUPON_VERIFY_ITEM';